// @flow
import React from 'react'
import i18n from 'i18n-react'

// types
export type InputType =
  'checkbox' | 'email' | 'password' | 'radio' | 'submit' | 'text' | 'textArea' | 'hidden' | 'number' |
  'image' | 'pid' | 'phone' | 'zip' | 'date' | 'datetime' | 'time'

type FieldValidationError = {

}

export type DefaultFormFieldType = {
	debug?: boolean,
	disabled?: boolean,
	id: string,
	label?: string,
	name: string,
	onChange?: (string | number, ?boolean) => void,
	textMode?: boolean,
	value: any,
  className?: string,
  help?: string,
  name: string,
  onErrorChange?: (Object) => void,
  placeholder?: string,
  readOnly?: boolean,
  required?: boolean,
  type?: InputType,
  validationErrors?: { [key: string]: { [key: string]: string }},
}

export default class AbstractFormField<T, S> extends React.Component<T, S> {

  static defaultProps = {
    className: '',
    disabled: false,
    onChange: () => {},
    onErrorChange: () => {},
    required: true,
    type: 'text',
    pristine: true,
  }

  state = { pristine: true }

  componentDidUpdate() {
    if (!this.hasErrors() && !this.state.pristine) {
      this.setState({ pristine: true })
    }
  }

  hasErrors = () => !!this.getErrors()

  getErrors = (): boolean | FieldValidationError => {
    const error: boolean | FieldValidationError = this.props.validationErrors ? this.props.validationErrors[this.props.name] : false
    if (error && error.error_type) {
      return error
    }
    return false
  }

  getMessageFromValidationError = (validationError: FieldValidationError) => validationError

  getErrorText = () => {
    const error = this.getMessageFromValidationError(this.getErrors())
    if (!error) {
      return ''
    }
    return i18n.translate(`vehicleInfoGeneral.validationErrors.${this.props.name}.${error.error_type}`, error.data || {})
  }

  onBlur = (event: { target: { value: string | number } }) => {
    this.setState({ pristine: false })
  }

  isPristine = () => this.state.pristine && this.props.isPristine

  render() {
    return (
      <p>Field named '{this.props.name}' of type '{this.props.type}' is not defined</p>
    )
  }
}
